<template>
  <div class="all_customer_style">
    <div class="fixed_search" :style="searchHeight">
      <Form ref="formValidate" :model="formValidate" class="form_submit_style">
        <FormItem>
          <Select v-model="formValidate.customerScope" placeholder="请选择客户范围" class="tab_change_style" @on-change="handleSearch()">
            <Option v-for="(option, index) in customerScopeList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </FormItem>
        <FormItem v-for="(item,index) in formValidate.searchList" :key="index">
          <Input v-if="item.type=='text' || item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

          <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                           :editable="editable" :picker-options="item.customColName=='nextConnectTime'?pickerOptionsAndFuture:pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

          <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue" :disabled="formValidate.customerScope=='0' && item.customColName=='customerManager'">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <Select v-if="item.type=='checkbox'" :placeholder="item.customName" class="multiple_search"  :title="item.customName" clearable multiple :max-tag-count="2" v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

          <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
        </FormItem>
        <FormItem class="fixed_operation_btn senior_search">
          <el-popover  placement="bottom" width="400" trigger="click" v-if="formValidate.seniorList.length>0" :visible-arrow="visible">
            <div v-for="(item,index) in formValidate.seniorList" :key="index">
              <Input v-if="item.type=='text'||item.type=='textarea'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

              <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                               :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

              <Select v-if="item.type=='select' || item.type=='radio'" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
              </Select>

              <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

              <Select v-if="item.type=='checkbox'" class="multiple_style" :placeholder="item.customName" :title="item.customName" clearable multiple  :max-tag-count="2" v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
              </Select>

              <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
            </div>
            <el-button slot="reference"><div class="btn_font_search">高级搜索</div></el-button>
          </el-popover>
          <Button type="primary" class="search_btn"  @click="initSearch()" style="margin-left: 10px">查询</Button>
          <Button type="primary" style="margin-left: 10px" class="search_btn reset_btn"  @click="handleReset()">重置</Button>
        </FormItem>
      </Form>
    </div>
    <div class="public_btn" v-if="showPublicBtn">
      <Button class="search_btn template_btn" v-if="roleList['1_2-1']" @click="addInsertCustomer('客户管理=>全部客户=>添加','1_2-1')">添加</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-2']" @click="excelImportList('客户管理=>全部客户=>导入','1_2-2')">导入</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-3']" @click="excelGlanceList('客户管理=>全部客户=>导出','1_2-3')">导出</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-4']" @click="distributionCustomer('客户管理=>全部客户=>分配','1_2-4')">分配</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-5']" @click="shareCustomer('客户管理=>全部客户=>共享','1_2-5')">共享</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-6']" @click="batchDeleteOperate('客户管理=>全部客户=>批量删除','1_2-6')">批量删除</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-7']" @click="moreBtn('1_2-7','解除客户分配')">解除分配</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-8']" @click="moreBtn('1_2-8','转到公海客户')">转到公海</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-9']" @click="moreBtn('1_2-9','解除客户共享')">解除共享</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-10']" @click="moreBtn('1_2-10','放弃客户')">放弃客户</Button>
      <Button class="search_btn template_btn" v-if="roleList['1_2-11']" @click="sendGroupMessage()">短信群发</Button>
    </div>
    <div class="fixed_table flexmytable">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection" :class="{'tableClass':tableClass}" @sort-change="sortChange"  @cell-click="openCallScreen" :cell-class-name="returnClassName"  @selection-change="getSelectedId">
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :key="item.key" :fixed="item.fixed" sortable="custom" :index="index" :prop="item.key" :label="item.title" :width="item.width">
          <!-- 头数据 -->
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top">
              <span>{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" >
            <!-- 附件 -->
            <el-tooltip placement="top" effect="light" v-if="item.customColSource != undefined && item.customColSource.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined" >
              <span style="color: #2d8cf0;" v-show="JSON.parse(scope.row[item.key]).length!=0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
              <div slot="content">
                <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                  <a style="font-size:14px;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                </p>
              </div>
            </el-tooltip>

            <!-- 其他 -->
            <span v-else>{{scope.row[item.key]}}</span>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="220" v-if="contentList.length>0"  align="center">
          <template slot-scope="scope">
            <el-button v-if="roleList['1_2-13']"  @click="openServiceDetail(scope.row.id,scope.row)" type="text" size="small">服务详情</el-button>
            <el-button v-if="roleList['1_2-14']" @click="editInsertCustomer('客户管理=>全部客户=>编辑','1_2-14',scope.row.id)" type="text" size="small">编辑</el-button>
            <el-button v-if="roleList['1_2-15']" @click="deleteOperate('客户管理=>全部客户=>删除','1_2-15',scope.row.id)" type="text" size="small">删除</el-button>
            <el-button v-if="roleList['1_2-16']" @click="openCustomerTrajectory(scope.row)" type="text" size="small">客户轨迹</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent"  @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <deleteTitlePop @closeTitlePop="closeTitlePop" :showTitlePop="showTitlePop" :publicTitle="deleteTitle"></deleteTitlePop>
    <InsertCustomerPop @closeInsertCustomer="closeInsertCustomer" :customerScope="formValidate.customerScope" :showInsertPop="showInsertPop" :searchId="searchId" :journalType="journalType" :menuId="menuId" :formValidate="formValidate" :showCustomerTitle="showCustomerTitle"></InsertCustomerPop>
    <excelExportPop @closeExcelExport="closeExcelExport" :showExcelExport="showExcelExport" :exportSign="exportSign" :publicTitle="publicTitle"></excelExportPop>
    <shareDistributionPop @closeShowPage="closeShowPage" :sign="sign" :total="total" :checkIds="checkIds" :showPage="showPage"></shareDistributionPop>
    <ImportCustomerPop @closeImport="closeImport" :showImportPop="showImportPop" :uploadSign="uploadSign"></ImportCustomerPop>
    <publicPop @closePublicPop="closePublicPop" :pubTitle="pubTitle" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
    <publicDialerPage  @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer"  :callUpPhone="callUpPhone" ></publicDialerPage>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone"></PublicSendMessage>
    <serviceDetailPop  @closeServiceDetail="closeServiceDetail"  @openTel="openTel" :showServiceDetail="showServiceDetail"  :customerServiceId="customerServiceId" :customerInfo="customerInfo"></serviceDetailPop>
    <sendGroupMessagePop  @closeSendGroupMessage="closeSendGroupMessage"  :showSendGroupMessage="showSendGroupMessage" :queryParam="queryParam" :checkIds="checkIds"></sendGroupMessagePop>
    <customerTrajectory @closeCustomerTrajectory="closeCustomerTrajectory" :showCustomerTrajectory="showCustomerTrajectory" :trajectoryId="trajectoryId" :customerName="customerName"></customerTrajectory>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublic} from '@/components/js/CustomerPublic.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  import deleteTitlePop from '@/components/customerMange/DeleteTitlePop.vue'
  import sendGroupMessagePop from '@/components/customerMange/SendGroupMessagePop.vue'
  import InsertCustomerPop from '@/components/customerMange/InsertCustomerPop.vue'
  import excelExportPop from '@/components/customerMange/ExcelExportPop.vue'
  import shareDistributionPop from '@/components/customerMange/ShareDistributionPop.vue'
  import customerTrajectory from '@/components/customerMange/CustomerTrajectoryPop.vue'
  import ImportCustomerPop from '@/components/customerMange/ImportCustomerPop.vue'
  import publicPop from '@/components/customerMange/PublicPop.vue'
  import serviceDetailPop from '@/components/customerMange/ServiceDetailPop.vue'
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  export default {
    name: "WholeCustomer",
    mixins:[publicFunClass,customerPublic,customerPublicBtn],
    props:{
      cusType:String,
      pageCode:String,
      breadList:Array
    },
    components:{
      deleteTitlePop,
      InsertCustomerPop,
      excelExportPop,
      shareDistributionPop,
      ImportCustomerPop,
      publicPop,
      serviceDetailPop,
      publicDialerPage,
      PublicSendMessage,
      sendGroupMessagePop,
      customerTrajectory,
    },
    data(){
      return {
        showPageCount:0,
        formValidate:{"customerScope":"0","customerState":"0","searchList":[],"seniorList":[],"allColumnInfo":[]},
        searchId: '',
        allColumnList:[],
        clientHeight:600,
        searchHeight:{'height':''},
        showCustomerTrajectory:false,
        trajectoryId:'',
        customerName:'',
        myColor: true,
        spinShow: true,
        showSendGroupMessage: false,
        tableClass: true,
        showTitlePop: false,
        showImportPop: false,
        editable:false,
        visible: true,
        showExcelExport: false,
        showPublicPop: false,
        exportSign:'customer',
        showPage: false,
        customerType:'',
        sign:'0',
        popSign:'解除客户分配',
        pubTitle:'',
        wholeColor: false,
        showPublicBtn: false,
        tableHeight:600,
        customerScopeList: [{'id': '0', 'name': '我的客户'}, {'id': '1', 'name': '全部客户'}],
        judgeList: [{'id': '0', 'name': '是'}, {'id': '1', 'name': '否'}],
        judge: '-1',
        checkedAll: false,
        total: 0,
        uploadSign: "0",
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        singleCheckedList: [],
        fieldList: [],
        contentList: [],
        checkIds:[],
        currentColName:'',
        journalType:'',
        menuId:'',
        tableCount:0,
        orderType:'',
        orderField:'',
        orderRule:'',
        showCustomerTitle:'添加客户',
        showInsertPop:false,
        deleteTitle:'批量删除客户',
        publicTitle:'导出客户',
        showfile:false,
        queryParam: null,
      }
    },
    methods:{
      openTel:function (row, column) {
        this.showServiceDetail=false;
        this.openCallScreen(row, column);
      },
      //设备信息当前页改变
      changeCurrent(event) {
        this.currentPage=event;
        this.initSearch();
      },
      //设备信息页面显示数量改变
      changeSize(event) {
        this.currentPage=1;
        this.pageSize=event;
        this.initSearch();
      },
      closeSendGroupMessage:function(){
        this.showSendGroupMessage=false;
      },
      sendGroupMessage:function(){
        this.showSendGroupMessage=true;
      },
      handleSearch:function () {
        this.handleReset();
        this.initSearch();
      },
      sortChange:function(event){
        if(event && event.order){
          let index=event.column.index;
          let obj=this.fieldList[index];
          this.orderType=obj.customIsSystem;
          this.orderField=obj.customColSource;
          this.orderRule=event.order=="descending"?"desc":"asc";
        }else{
          this.orderType="";
          this.orderField="";
          this.orderRule="";
        }
        this.initSearch();
      },
      initSearch:function () {
        let selectCount=false;
        let list=this.formValidate.searchList;
        for (let i=0;i<list.length;i++){
          let customValue=list[i].customValue;
          if(customValue){
            selectCount=true;
          }
        }
        let param={
          orderType:this.orderType,
          orderField:this.orderField,
          orderRule:this.orderRule,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null",
          selectCount:selectCount,
          customerType: this.customerType=="-1"?"":this.customerType,
          customerScope:this.formValidate.customerScope,
          customerState:this.formValidate.customerState
        };
        this.speedChangePage=this.currentPage;
        this.getParam(this.formValidate,param);
        let that=this;
        let phoneIsHide= this.configInfo.phoneIsHide;
        let phoneOwnership= this.configInfo.phoneOwnership;
        this.spinShow=true;
        // 查询条件
        this.queryParam = param;
        
        this.$http.post("customer/selectAllCustomer.json",param) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;
          that.fieldList = [];
          let fieldList=res.data.obj.fields;
          let count=0;
          for (let j=0;j<fieldList.length;j++) {
            let customIsShow=fieldList[j].customIsShow;
            if(customIsShow=='1'){
              count++;
            }
          }
          that.tableCount=count;
          that.checkIds=[];
          let paramList=[];
          let seniorList=[];
          let allColumnInfo=[];
          let countFix=1;
          that.total=res.data.obj.list.totalSize;
          for (let i=0;i<fieldList.length;i++){
            let customIsSearch=fieldList[i].customIsSearch;
            let customIsSystem=fieldList[i].customIsSystem;
            let customColSource=fieldList[i].customColSource;
            let customColName=fieldList[i].customColName;
            let customName=fieldList[i].customName;
            let customType=fieldList[i].customType;
            let customIsMust=fieldList[i].customIsMust;
            let customIsShow=fieldList[i].customIsShow;
            let customIsAlter=fieldList[i].customIsAlter;
            //高级搜索过滤客户经理查询
            if(param.customerScope == '0' && customColName.indexOf('customerManager') != -1){
              continue;
            }
            if(paramList.length>9 && customIsSearch=='1'){
              customIsSearch='2';
            }
            if(customColName=="customerId"){
              customColName="customerName";
            }
            if(customColName=="employeeId"){
              customColName="employeeName";
            }
            let tableHead={
              title: customName,
              key: customColName,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              height:40
            };

            if(count>10){
              tableHead["width"]="150";
              if(customIsShow=='1' && countFix<4){
                countFix++;
                tableHead["fixed"]=true
              }
            }
            if(customIsShow=='1'){
              if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1){
                if(phoneIsHide=='1'){
                  tableHead.key=customColName+"Hide";
                }
                that.fieldList.push(tableHead);
                if(phoneOwnership=='1'){
                  let tableHead1={
                    title: customName+"归属地",
                    key: customColName+"Address",
                    customIsSystem:customIsSystem,
                    customColSource:customColSource,
                    height:40
                  };
                  if(count>10){
                    tableHead1["width"]="150";
                    if(customIsShow=='1' && countFix<4){
                      countFix++;
                      tableHead1["fixed"]=true
                    }
                  }
                  that.fieldList.push(tableHead1);
                }
              }else {
                that.fieldList.push(tableHead);
              }
            }
            let columnParam={
              type: customType,
              customColName: customColName,
              customValue:customType=='cascade'?[]:'',
              popCustomValue:customType=='cascade'?[]:'',
              checkName:"customValue",
              customIsMust:customIsMust,
              customName:customName,
              customIsSearch:customIsSearch,
              customIsAlter:customIsAlter,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              list:fieldList[i].list,
            };
            allColumnInfo.push(columnParam);
            if(customIsSearch=='1'){
              if(that.cusType=="-1"){
                paramList.push(columnParam);
              }else {
                if(customColName!="customerType"){
                  paramList.push(columnParam);
                }
              }
            }
            if(customIsSearch=='2'){
              seniorList.push(columnParam);
            }
          }
          let searchParam=that.formValidate.searchList;
          for (let i=0;i<paramList.length;i++){
            let colName=paramList[i].customColName;
            for (let j=0;j<searchParam.length;j++){
              let name=searchParam[j].customColName;
              if(colName==name){
                paramList[i].customValue=searchParam[j].customValue
              }
            }
          }
          let seniorParam=that.formValidate.seniorList;
          for (let m=0;m<seniorList.length;m++){
            let colName=seniorList[m].customColName;
            for (let n=0;n<seniorParam.length;n++){
              let name=seniorParam[n].customColName;
              if(colName==name){
                seniorList[m].customValue=seniorParam[n].customValue
              }
            }
          }
          that.formValidate.searchList=paramList;
          that.formValidate.seniorList=seniorList;
          that.formValidate.allColumnInfo=allColumnInfo;
          let length=(paramList.length+2)>6?2:1;
          let height=length*40;
          that.searchHeight.height= height+"px";
          that.tableHeight=that.clientHeight-132-height;
          if (that.showPublicBtn) {
            that.tableHeight=that.clientHeight-182-height;
          }
        });
      }
    },
    created(){
      this.initPublicBtn(1,12,'1_2-');
      this.clientHeight=document.documentElement.clientHeight;
    },
    mounted(){
      this.customerType=this.cusType;
    },
    destroyed(){
      let cacheCustomerList={};
      localStorage.setItem("cacheCustomerList",JSON.stringify(cacheCustomerList));
    },
    watch:{
      cusType:function () {
        console.log("cusType");
        let cacheCustomer={
          formValidate:this.formValidate,
          contentList:this.contentList,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          customerType: this.customerType,
          queryParam: this.queryParam,
        };
        let cacheCustomerList=JSON.parse(localStorage.getItem("cacheCustomerList"));
        cacheCustomerList[this.customerType]=cacheCustomer;
        if(this.cusType=="-2"){
          return false;
        }
        let resetLabel=localStorage.getItem("resetLabel");
        localStorage.setItem("resetLabel","");
        if(resetLabel){
          cacheCustomerList[resetLabel]="";
        }
        this.customerType=this.cusType;
        localStorage.setItem("cacheCustomerList",JSON.stringify(cacheCustomerList));
        if(cacheCustomerList[this.cusType]){
          let object=cacheCustomerList[this.cusType];
          this.formValidate=object.formValidate;
          this.contentList=object.contentList;
          this.pageNum=object.currentPage;
          this.pageSize=object.pageSize;
          this.customerType=object.customerType;
          this.queryParam=object.queryParam;
          return false;
        }
        this.handleReset();
        this.initSearch();
      },
      pageCode:function () {
        if(this.pageCode.indexOf('1_2')!=-1 && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
          this.handleScroll();
        }
      }
    }
  }
</script>

<style>
 .flexmytable .el-table th>.cell{
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/customerMange/WholeCustomer.vue